import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import OverflowTabs, { ITabItem } from 'app/shared/common-fun/OverflowTabs';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { useDispatch } from 'react-redux';
import { getEntityNotifications } from 'app/entities/notification/notification.reducer';
import { getEntityFilterConnections } from 'app/entities/connection/connection.reducer';
import { getEntityProfileDetails, getUserMentorMenteeCount } from 'app/entities/user-profile/user-profile.reducer';
import { getEntityTotalPoints } from 'app/entities/point-allocation/point-allocation.reducer';
import { getEntityMentorTopic } from 'app/entities/mentor-topic/mentor-topic.reducer';
import { getEntityInterviewDetails, getEntityMeetingDetails } from 'app/entities/meetinginfo/meetinginfo.reducer';
import { getEntityMenteeQuestions } from 'app/entities/question/question.reducer';
import { getEntityMenteeTopic } from 'app/entities/mentee-topic/mentee-topic.reducer';
import { getEntities, getEntityInspirations } from 'app/entities/inspiration/inspiration.reducer';
interface Props {
  tab1Content: React.ReactNode;
  tab2Content: React.ReactNode;
  tab3Content: React.ReactNode;
  tab4Content: React.ReactNode;
  tab5Content: React.ReactNode;
  tab6Content: React.ReactNode;
  tab7Content: React.ReactNode;
  tab8Content?: React.ReactNode;
  tab9Content?: React.ReactNode;
  currentActiveTab: React.ReactNode;
}

const tabItems: ITabItem[] = [
  { id: 'connections', label: 'Connections', icon: 'content/images/MyConnections-icon.svg' },
  { id: 'profile', label: 'My Profile', icon: 'content/images/My-Profile-icon.svg' },
  { id: 'meetings', label: 'Meetings', icon: 'content/images/Meetings-icon.svg' },
  { id: 'inspirations', label: 'Inspirations', icon: 'content/images/Inspiration-icon.svg' },
  { id: 'earn', label: 'Earn More Points', icon: 'content/images/ChartDonut.svg' },
  { id: 'interviews', label: 'Interviews', icon: 'content/images/Meetings-icon.svg' },
  { id: 'introvideo', label: 'Personal video', icon: 'content/images/Meetings-icon.svg' },
  { id: 'housing', label: 'Housing', icon: 'content/images/Inspiration-icon.svg' },
  { id: 'governance', label: 'Good Governance', icon: 'content/images/Inspiration-icon.svg' },
];

const Tabs: React.FC<Props> = ({
  tab1Content,
  tab2Content,
  tab3Content,
  tab4Content,
  tab5Content,
  tab6Content,
  tab7Content,
  tab8Content,
  tab9Content,
  currentActiveTab,
}) => {
  const [activeTab, setActiveTab] = useState('');
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const account = useAppSelector(state => state.authentication.account);
  const id = account.id;
  // console.log(id, 'myiddd');

  const getTabFromUrl = () => {
    const params = new URLSearchParams(location.search);
    return params.get('tab') || 'profile';
  };

  const tab = getTabFromUrl();

  useEffect(() => {
    if (currentActiveTab == 'inspirations') {
      setActiveTab('inspirations');
    } else if (tab == 'connections') {
      setActiveTab('connections');
    } else {
      setActiveTab('profile');
    }
    // console.log('currentActiveTab', currentActiveTab);
    // setInspirationData(inspirationEntity);
  }, [currentActiveTab]);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const handleOk = () => {
    setModalOpen(false);
    setActiveTab('earn');
  };
  const toggle = async (tab: string) => {
    setLoading(true);
    if (activeTab !== tab) setActiveTab(tab);

    if (tab === 'connections') {
      await dispatch(getEntityNotifications(id));
      await dispatch(getEntityFilterConnections(['connection', 'all'])); // Dispatch action for tab 1
    } else if (tab === 'profile') {
      await dispatch(getEntityNotifications(id));
      await dispatch(getEntityProfileDetails(id));
      await dispatch(getEntityTotalPoints());
      await dispatch(getEntityMentorTopic(id));
      await dispatch(getEntityMenteeQuestions(id));
      await dispatch(getEntityMenteeTopic(id));
      await dispatch(getUserMentorMenteeCount());
    } else if (tab === 'meetings') {
      await dispatch(getEntityNotifications(id));
      await dispatch(getEntityMeetingDetails({ page: 0, size: 20 }));
    } else if (tab === 'interviews') {
      await dispatch(getEntityNotifications(id));
      await dispatch(getEntityInterviewDetails({ page: 0, size: 20 }));
    } else if (tab === 'inspirations') {
      await dispatch(getEntityNotifications(id));
      await dispatch(
        getEntityInspirations({
          id: id,
          page: 0,
          size: 20,
          sort: 'id,desc',
        })
      );
    } else if (tab === 'inspirations') {
      await dispatch(getEntityNotifications(id));
      await dispatch(
        getEntityInspirations({
          id: id,
          page: 0,
          size: 10,
          sort: 'id,desc',
        })
      );
    } else if (tab === 'housing') {
      await dispatch(getEntityNotifications(id));
    } else if (tab === 'governance') {
      await dispatch(getEntityNotifications(id));
    } else if (tab === 'earn') {
      setModalOpen(true);
      return; // Exit the function to avoid setting loading to false immediately
    }
    setTimeout(() => {
      // console.log('loading');
      setLoading(false);
    }, 500);
  };

  return (
    <div className="wrapper">
      <OverflowTabs items={tabItems} activeTab={activeTab} onSelect={tab => void toggle(tab)} />
      {/* <TabContent activeTab={activeTab}>
        <TabPane tabId="connections">{tab1Content}</TabPane>
        <TabPane tabId="profile">{tab2Content}</TabPane>
        <TabPane tabId="meetings">{tab3Content}</TabPane>
        <TabPane tabId="inspirations">{tab4Content}</TabPane>
        <TabPane tabId="newsfaeed">{tab5Content}</TabPane>
      </TabContent> */}
      <TabContent activeTab={activeTab}>
        <TabPane tabId="connections">{activeTab === 'connections' && tab1Content}</TabPane>
        <TabPane tabId="profile">{activeTab === 'profile' && tab2Content}</TabPane>
        <TabPane tabId="meetings">{activeTab === 'meetings' && tab3Content}</TabPane>
        <TabPane tabId="inspirations">{activeTab === 'inspirations' && tab4Content}</TabPane>
        <TabPane tabId="earn">{activeTab === 'earn' && tab5Content}</TabPane>
        <TabPane tabId="interviews">{activeTab === 'interviews' && tab6Content}</TabPane>
        <TabPane tabId="introvideo">{activeTab === 'introvideo' && tab7Content}</TabPane>
        <TabPane tabId="housing">{activeTab === 'housing' && tab8Content}</TabPane>
        <TabPane tabId="governance">{activeTab === 'governance' && tab9Content}</TabPane>
      </TabContent>

      <Modal className="points-popup" isOpen={modalOpen} toggle={toggleModal}>
        <ModalBody>
          {/* Modal content here */}
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <img src="content/images/header-logo.png" alt="Logo" style={{ maxWidth: '80px', marginBottom: '10px' }} />
            <h2>Introducing Points</h2>
          </div>
          <div className="points-popup-content">
            <div>
              <img src="content/images/learn-earn-icon.svg" alt="icon" />
            </div>
            <div>
              <h4> Learn + Earn:</h4>
              <p>As a mentee, you have the opportunity to learn and gain valuable knowledge.</p>
              <p>As a mentor, you can share your expertise and guide others in their learning journey.</p>
            </div>
          </div>
          <div className="points-popup-content">
            <div>
              <img src="content/images/buy-icon.svg" alt="icon" />
            </div>
            <div>
              <h4>Buy:</h4>
              <p>If you need to accumulate additional points, you can purchase more to top off your balance.</p>
            </div>
          </div>
          <div className="points-popup-content">
            <div>
              <img src="content/images/give-icon.svg" alt="icon" />
            </div>
            <div>
              <h4>Give:</h4>
              <p>Donate your points to support causes and initiatives you care about.</p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleOk}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Tabs;
